var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentsTrackingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#BF3B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3976 19.9466L29.9778 16.9587L24.3976 13.9707L18.8174 16.9587L24.3976 19.9466Z",
    fill: "#E0ABA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4336 21.5915V27.5673L31.0137 24.5794V18.6035L25.4336 21.5915Z",
    fill: "#E0ABA3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3638 21.5915L17.7837 18.6035V24.5794L23.3638 27.5673V21.5915Z",
    fill: "#E0ABA3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5628 11.9018C31.8306 9.37526 28.2048 7.98712 24.3572 8.00009C16.4406 8.02167 10 14.0061 10 21.3404C10 23.8519 10.745 26.4108 12.2144 28.9458C13.37 30.9395 14.975 32.9235 16.9847 34.8427C20.3827 38.0875 24.4154 40.4002 24.4154 40.4002C24.4154 40.4002 28.4401 38.0869 31.8306 34.844C33.836 32.9259 35.4374 30.9433 36.5906 28.9515C38.0566 26.4189 38.8 23.8631 38.8 21.3551C38.7999 17.7858 37.2952 14.4285 34.5628 11.9018ZM33.0506 25.6754L24.4 30.3075L15.7494 25.6754V16.4113L24.4 11.7794L33.0506 16.4114V25.6754Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentsTrackingActive);
export default __webpack_public_path__ + "static/media/shipments-tracking-active.f3bbd2afb08bfd075374c786b681b5c4.svg";
export { ForwardRef as ReactComponent };